export default __webpack_public_path__ + "static/media/footer_v3.f2504bf8.png";